import { createFileRoute, useNavigate, useParams } from "@tanstack/react-router";

import { AcceptWorkOrderMobileForm } from "@/components/domain/WorkOrder/Mobile/Accept/forms/Accept/accept.tsx";
import { SelectCompanionMobileForm } from "@/components/domain/WorkOrder/Mobile/Accept/forms/Companions/SelectCompanion.tsx";
import {
  AcceptWorkOrderFormContainer,
  STEPS,
  type WorkOrderMobileStepsType,
} from "@/components/domain/WorkOrder/Mobile/Accept/AcceptWorkOrderContainer.tsx";
import { useState } from "react";
import { AddCompanionFormWorkOrderMobileForm } from "@/components/domain/WorkOrder/Mobile/Accept/forms/Companions/add-companion.form.tsx";
import { authGuardWithPermissions } from "@/utils/authGuard.ts";
import type { RouterContextType } from "@/api/permissions/permissions.api.ts";

export const Route = createFileRoute("/_authenticated/mobile/work-order/accept/$Id/")({
  component: WorkOrderMobileAcceptPage,
  beforeLoad: async (args) => {
    await authGuardWithPermissions({
      context: args.context as RouterContextType,
      location: args.location as { pathname: string },
    });
  },
});

function WorkOrderMobileAcceptPage() {
  const [step, setStep] = useState<WorkOrderMobileStepsType>("accept");
  const { Id } = useParams({ from: "/_authenticated/mobile/work-order/accept/$Id/" });

  const navigate = useNavigate();
  return (
    <div style={{ width: "100%", minHeight: "100vh", height: "100%", backgroundColor: "#EFF1F2" }}>
      <AcceptWorkOrderFormContainer onStepChange={setStep}>
        {step === STEPS.accept && (
          <AcceptWorkOrderMobileForm
            onSubmit={() => navigate({ to: `/mobile/work-order/details/${Id}` })}
          />
        )}
        {step === STEPS.companion && <SelectCompanionMobileForm />}
        {step === STEPS.addCompanion && <AddCompanionFormWorkOrderMobileForm />}
      </AcceptWorkOrderFormContainer>
    </div>
  );
}
